import React from "react";
import { PublicQuizContent } from "./PublicQuizContent";

export default function PublicQuiz() {
  return <PublicQuizContent />;
}

